<style scoped>
</style>
<template>
    
    <div class="table-responsive" style=" height:100%;">
        <datatable :columns="columns" :source="getRecords" @selected="recordSelected" :datachanged="refreshIndex"></datatable>
    </div>
</template>
<script>
    import $ from 'jquery'
    import FmdDal from '../../../scripts/FmdDal'
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import Formatter from "../../corecontrols/formatters/Formatter"
    import toastr from "toastr"

    export default {
        props: [
            'statuses',
            'patientId'
            //'fromDate',
            //'toDate',
        ],
        data: function () {
            var formatDate = Formatter.FormatDate;

            return {
                refreshIndex: 0,
                //statuses: [10, 20, 30],
                bags: [],
                FmdDal: null,
                columns: [
                    {
                        name: "", "orderable": false, render: function (data, type, row, meta) {
                            return "#" + meta.row;
                        }
                    },
                    {
                        name: "FMD Status", data: "bagFMDStatus", render: function (data, type, row) {
                            var icon = "fa-refresh"
                            var style = "text-primary"
                            var text = ""
                            if (data == "10") {
                                icon = "fa-hourglass"
                                style = "text-warning"
                                text = "Pending"
                            }
                            if (data == "20") {
                                icon = "fa-check"
                                style = "text-success"
                                text = "Verified"
                            }
                            if (data == "30") {
                                icon = "fa-exclamation-triangle"
                                style = "text-danger"
                                text = "Failed"
                            }
                            return "<div class='" + style + "'><i class='fa " + icon + "'></i> <span>" + text + "</span> </div>";
                        }
                    },
                    {
                        name: "Bag Status", data: "bagStatus", render: function (data, type, row) {
                            var icon = "fa-refresh"
                            var style = "text-primary"
                            var text = ""
                            if (data == "0") {
                                icon = "fa-trash"
                                style = "text-danger"
                                text = "Deleted"
                            } if (data == "10") {
                                icon = "fa-cog"
                                style = "text-warning"
                                text = "Working"
                            }
                            if (data == "20") {
                                icon = "fa-shopping-bag"
                                style = "text-success"
                                text = "Completed"
                            }
                            if (data == "30") {
                                icon = "fa-paper-plane"
                                style = "text-success"
                                text = "Delivered"
                            }
                            return "<div class='" + style + "'><i class='fa " + icon + "'></i> <span>" + text + "</span> </div>";
                        }
                    },
                    {
                        name: "Name",
                        render: function (data, type, row) {
                            return row.firstName + ' ' + row.lastName;
                        }
                    },
                    {
                        name: "Aggregated Code",
                        data: "aggregatedCode"
                    },
                    {
                        name: "Created", data: "whenCreated", render: function (data, type, row) {
                            return Formatter.FormatDateTime(data)
                        }
                    },
                    {
                        name: "Dob", data: "dob", render: function (data, type, row) {
                            return formatDate(data)
                        }
                    },
                    {
                        name: "Items", data: "numberOfMeds", render: function (data, type, row) {
                            return data
                        }
                    }
                ]
            }
        },
        watch: {
            patientId: function () {
                this.refreshIndex++;
            }
        },
        mounted() {
            var unitId = this.$root.CurrentUnitId;
            this.FmdDal = new FmdDal(unitId, this.$root.UiSession);
            this.refreshIndex++;
        },
        methods: {
            //getRecords(drawIndex, start, length, searchText, sortColumnName, sortDirection, callback) {

            //    if (this.dal) {
            //        this.dal.GetBags(start, length, this.patientId, this.statuses, searchText).then(d => {
            //            var result = {
            //                draw: drawIndex,
            //                recordsTotal: d.totalCount,
            //                recordsFiltered: d.totalCount,
            //                data: d.data
            //            }

            //            callback(result);
            //        })
            //    }
            //},

            getRecords: function (callback) {
                if (!this.FmdDal) {
                    callback({ data: [] });
                    return;
                }

                var start = 0;
                var length = 500;
                var searchText = null;
                //if (this.FmdDal) {

                this.FmdDal.GetBags(start, length, this.patientId, this.statuses, searchText).then(d => {
                    this.bags = d;
                    callback({ data: this.bags })
                })
                //}
            },
            //filteredBags() {
            //    return this.bags;
            //},
            recordSelected(record) {
                console.log("Record Selected", record);
                this.$router.push({ path: '/fmd/bag/' + record.id });
            }
        },
        components: {
            datatable
        }
    }
</script>


// WEBPACK FOOTER //
// baglist.scp.html?14af1c94